import { API_BASE } from "@/lib/api";

const DURATION_MS = 60 * 60 * 1000;

const stamp = (date) => date.toISOString().replace(/[-:]/g, "").replace(/\.\d{3}/, "");
const isoNoMs = (date) => date.toISOString().replace(/\.\d{3}Z$/, "Z");

export function calendarLinks({ registrationId, calendarToken, iso, title, details, location }) {
  const start = new Date(iso);
  const end = new Date(start.getTime() + DURATION_MS);
  const google = new URLSearchParams({
    action: "TEMPLATE",
    text: title,
    dates: `${stamp(start)}/${stamp(end)}`,
    details,
    location,
    ctz: "Asia/Singapore",
  });
  const outlook = new URLSearchParams({
    path: "/calendar/action/compose",
    rru: "addevent",
    subject: title,
    startdt: isoNoMs(start),
    enddt: isoNoMs(end),
    body: details,
    location,
  });
  return {
    google: `https://calendar.google.com/calendar/render?${google}`,
    outlook: `https://outlook.live.com/calendar/0/deeplink/compose?${outlook}`,
    ics: `${API_BASE}/registrations/${registrationId}/calendar.ics?t=${encodeURIComponent(calendarToken || "")}`,
  };
}
